// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__cVGrL","divMain":"Banner_divMain__qsoLQ","divText":"Banner_divText__E93Ng","btnScrollDown":"Banner_btnScrollDown__aUZUZ"};